import React from "react";
import { Route, Routes } from "react-router-dom";
import { AdminPackagesPage } from "@/pages/Admin/Packages";
import { AdminModulesPage } from "@/pages/Admin/Modules";
import { PromotionalPricingPage } from "@/pages/Admin/Promotions/PromotionalPricingPage";
import AdminEditPackagePage from "@/pages/Admin/Packages/Edit";
import AdminEditModulePage from "@/pages/Admin/Modules/Edit";
import AdminAccessPage from "@/pages/Admin/Access";
import StudentManagementPage from "@/pages/Admin/Access/StudentManagement";
import TeacherManagementPage from "@/pages/Admin/Access/TeacherManagement";
import SpecialAccessUserManagementPage from "@/pages/Admin/Access/SpecialAccessUserManagement";
import AdminEducationalPage from "@/pages/Admin/Educational";
import AdminReportsPage from "@/pages/Admin/Reports";
import AccessesByDayPage from "@/pages/Admin/Reports/AccessesByDay/accessesByDayPage";
import RegistrationsByDayPage from "@/pages/Admin/Reports/RegistrationsByDay/registrationsByDayPage";
import AdminVouchersPage from "@/pages/Admin/Vouchers";
import AdminEditVoucherPage from "@/pages/Admin/Vouchers/Edit";
import CreateVoucherPage from "@/pages/Admin/Vouchers/CreateVoucher";
import EditTeacher from "@/pages/Admin/Access/EditTeacher";
import EditStudent from "@/pages/Admin/Access/EditStudent";
import StudentPackageManagementPage from "@/pages/Admin/Access/StudentPackageManagementPage";
import StudentModuleTestReportPage from "@/pages/Admin/Access/StudentModuleTestReportPage";
import AdminDashboardPage from "@/pages/Admin/Dashboard/AdminDashboardPage";
import EditSpecialAccessUser from "@/pages/Admin/Access/SpecialAccessUserManagement/EditSpecialAccessUser";
import VocabularyGroupManagement from "@/pages/Admin/Educational/VocabularyManagement";
import AdminEditVocabularyGroupPage from "@/pages/Admin/Educational/VocabularyManagement/Edit";
import PrivateRoute from "./PrivateRoute";
import { AuthRole } from "@/services/shared/auth/auth.interfaces";
import LevelTestsManagementPage from "@/pages/Admin/Educational/LevelTestsManagement";
import EditLevelTestGroupPage from "@/pages/Admin/Educational/LevelTestsManagement/Edit";
import ModuleTestsListPage from "@/pages/Admin/Educational/ModuleTestsManagement";
import EditModuleTestPoolPage from "@/pages/Admin/Educational/ModuleTestsManagement/Edit";
import AdminStudentLevelTestPage from "@/pages/Admin/Students/LevelTest";
import { AdminOrdersPage, AdminOrderDetailPage } from "@/pages/Admin/Orders";

const AdminRoutes = () => {
  return (
    <Routes>
      <Route
        path="dashboard"
        element={
          <PrivateRoute
            component={AdminDashboardPage}
            userRole={AuthRole.Admin}
          />
        }
      />

      {/* Packages */}
      <Route
        path="packages"
        element={
          <PrivateRoute
            component={AdminPackagesPage}
            userRole={AuthRole.Admin}
          />
        }
      />
      <Route
        path="packages/:packageId"
        element={
          <PrivateRoute
            component={AdminEditPackagePage}
            userRole={AuthRole.Admin}
          />
        }
      />
      <Route
        path="packages/:packageId/modules/:moduleId"
        element={
          <PrivateRoute
            component={AdminEditModulePage}
            userRole={AuthRole.Admin}
          />
        }
      />

      {/* Modules */}
      <Route
        path="modules"
        element={
          <PrivateRoute
            component={AdminModulesPage}
            userRole={AuthRole.Admin}
          />
        }
      />
      <Route
        path="modules/:moduleId"
        element={
          <PrivateRoute
            component={AdminEditModulePage}
            userRole={AuthRole.Admin}
          />
        }
      />

      {/* Educational */}
      <Route
        path="educational"
        element={
          <PrivateRoute
            component={AdminEducationalPage}
            userRole={AuthRole.Admin}
          />
        }
      />

      {/* Level Tests Management */}
      <Route
        path="educational/level-tests-management"
        element={
          <PrivateRoute
            component={LevelTestsManagementPage}
            userRole={AuthRole.Admin}
          />
        }
      />
      <Route
        path="educational/level-tests-management/:id"
        element={
          <PrivateRoute
            component={EditLevelTestGroupPage}
            userRole={AuthRole.Admin}
          />
        }
      />

      {/* Module Tests (pool per module) */}
      <Route
        path="educational/module-tests"
        element={
          <PrivateRoute
            component={ModuleTestsListPage}
            userRole={AuthRole.Admin}
          />
        }
      />
      <Route
        path="educational/module-tests/:moduleId"
        element={
          <PrivateRoute
            component={EditModuleTestPoolPage}
            userRole={AuthRole.Admin}
          />
        }
      />

      {/* Vocabulary Management */}
      <Route
        path="educational/vocabulary-management"
        element={
          <PrivateRoute
            component={VocabularyGroupManagement}
            userRole={AuthRole.Admin}
          />
        }
      />
      <Route
        path="educational/vocabulary-management/:groupId"
        element={
          <PrivateRoute
            component={AdminEditVocabularyGroupPage}
            userRole={AuthRole.Admin}
          />
        }
      />

      {/* Access Management */}
      <Route
        path="access"
        element={
          <PrivateRoute
            component={AdminAccessPage}
            userRole={AuthRole.Admin}
          />
        }
      />
      <Route
        path="access/students"
        element={
          <PrivateRoute
            component={StudentManagementPage}
            userRole={AuthRole.Admin}
          />
        }
      />
      <Route
        path="access/students/:studentId"
        element={
          <PrivateRoute
            component={EditStudent}
            userRole={AuthRole.Admin}
          />
        }
      />
      <Route
        path="access/students/:studentId/packages/:packageId"
        element={
          <PrivateRoute
            component={StudentPackageManagementPage}
            userRole={AuthRole.Admin}
          />
        }
      />
      <Route
        path="access/students/:studentId/packages/:packageId/modules/:moduleId/module-test"
        element={
          <PrivateRoute
            component={StudentModuleTestReportPage}
            userRole={AuthRole.Admin}
          />
        }
      />
      <Route
        path="access/students/:studentId/level-test"
        element={
          <PrivateRoute
            component={AdminStudentLevelTestPage}
            userRole={AuthRole.Admin}
          />
        }
      />
      <Route
        path="access/teachers"
        element={
          <PrivateRoute
            component={TeacherManagementPage}
            userRole={AuthRole.Admin}
          />
        }
      />
      <Route
        path="access/teachers/:teacherId"
        element={
          <PrivateRoute
            component={EditTeacher}
            userRole={AuthRole.Admin}
          />
        }
      />
      <Route
        path="access/users"
        element={
          <PrivateRoute
            component={SpecialAccessUserManagementPage}
            userRole={AuthRole.Admin}
          />
        }
      />
      <Route
        path="access/users/:userId"
        element={
          <PrivateRoute 
            component={EditSpecialAccessUser} 
            userRole={AuthRole.Admin} 
          />
        }
      />

      {/* Other Admin Pages */}
      <Route
        path="promotions"
        element={
          <PrivateRoute
            component={PromotionalPricingPage}
            userRole={AuthRole.Admin}
          />
        }
      />
      <Route
        path="reports"
        element={
          <PrivateRoute
            component={AdminReportsPage}
            userRole={AuthRole.Admin}
          />
        }
      />
      <Route
        path="reports/accesses-by-day"
        element={
          <PrivateRoute
            component={AccessesByDayPage}
            userRole={AuthRole.Admin}
          />
        }
      />
      <Route
        path="reports/registrations-by-day"
        element={
          <PrivateRoute
            component={RegistrationsByDayPage}
            userRole={AuthRole.Admin}
          />
        }
      />
      <Route
        path="vouchers"
        element={
          <PrivateRoute
            component={AdminVouchersPage}
            userRole={AuthRole.Admin}
          />
        }
      />
      <Route
        path="vouchers/create"
        element={
          <PrivateRoute
            component={CreateVoucherPage}
            userRole={AuthRole.Admin}
          />
        }
      />
      <Route
        path="vouchers/:voucherId"
        element={
          <PrivateRoute
            component={AdminEditVoucherPage}
            userRole={AuthRole.Admin}
          />
        }
      />

      {/* Orders */}
      <Route
        path="orders"
        element={
          <PrivateRoute
            component={AdminOrdersPage}
            userRole={AuthRole.Admin}
          />
        }
      />
      <Route
        path="orders/:orderId"
        element={
          <PrivateRoute
            component={AdminOrderDetailPage}
            userRole={AuthRole.Admin}
          />
        }
      />
    </Routes>
  );
};

export default AdminRoutes;